import { render, staticRenderFns } from "./social-media-form-edit.vue?vue&type=template&id=486b6a76&scoped=true"
import script from "./social-media-form-edit.vue?vue&type=script&lang=js"
export * from "./social-media-form-edit.vue?vue&type=script&lang=js"
import style0 from "./social-media-form-edit.vue?vue&type=style&index=0&id=486b6a76&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b6a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486b6a76')) {
      api.createRecord('486b6a76', component.options)
    } else {
      api.reload('486b6a76', component.options)
    }
    module.hot.accept("./social-media-form-edit.vue?vue&type=template&id=486b6a76&scoped=true", function () {
      api.rerender('486b6a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/social-media-form-edit.vue"
export default component.exports